import ApiBase from 'app/api/base';

export default class DesktopApi extends ApiBase {
  static init(store) {
    window.Groupon = Object.assign({}, window.Groupon, {
      LSApp: new DesktopApi(store),
    });
  }
}
